import { inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Data, NavigationEnd, Router } from '@angular/router';

import { filter, map, startWith } from 'rxjs';

/**
 * Data of the deepest activated route, re-read on every navigation.
 * Layout shells use it to react to route flags such as `fullBleed`/`fixedHeight`.
 */
export function injectLeafRouteData(): Signal<Data> {
  const router = inject(Router);

  const readLeafData = (): Data => {
    let route = router.routerState.snapshot.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    return route.data;
  };

  return toSignal(
    router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => readLeafData()),
      startWith(readLeafData())
    ),
    { initialValue: readLeafData() }
  );
}
